// translation.js
const translation = {

    // GENERAL
    pageTitulo: "Công cụ hỗ trợ quyết định phân tích thứ bậc (AHP)",
    buttonAdicionar: "Thêm",
    switchLanguage: "Chuyển sang tiếng Việt",
    ptSwitchLanguage: "VI",
    enSwitchLanguage: "EN",
    selectMethod: "CHỌN PHƯƠNG PHÁP",
    sim: "Có",
    nao: "Không",
    selecione: "Chọn",
    baixo: "Thấp",
    medio: "Trung bình",
    alto: "Cao",
    tituloFluxograma: "LƯU ĐỒ",
    tituloInputs: "THÔNG SỐ LỰA CHỌN",
    tituloIlustration: "MINH HỌA",
    exportProject: "Xuất dự án",
    importProject: "Nhập dự án",
    resetProject: "Đặt lại dự án",
    continueProject: "Tiếp tục dự án",
    step: "Tính",
    resultados: "KẾT QUẢ",

    // FOOTER
    universidadeFooter: "Đại học Bách Khoa Hà Nội",
    laboratorioFooter: "Phòng thí nghiệm Xử lý Khoáng sản",
    localizacaoUmFooter: "Số 1 Đại Cồ Việt, Hai Bà Trưng, Hà Nội",
    localizacaoDoisFooter: "Hà Nội, Việt Nam",
    contatoFooter: "Liên hệ: email@hust.edu.vn",
    linksFooter: "Liên kết",
    creditosFooter: "Người đóng góp",
    referenciasFooter: "Tài liệu tham khảo",
    reportarErroFooter: "Báo cáo lỗi",

    // POPUP CREDITS
    creditosTituloPopUp: "NGƯỜI ĐÓNG GÓP",
    universidadeCreditos: "ĐẠI HỌC BÁCH KHOA HÀ NỘI",
    laboratorioCreditos: "PHÒNG THÍ NGHIỆM XỬ LÝ KHOÁNG SẢN",
    versaoCreditos: "PHIÊN BẢN 1.0",
    tituloFerramentaCreditos: "Phân tích thứ bậc",
    tituloAutoresCreditos: "TÁC GIẢ",
    nomeAutoresCreditos: "HIGOR CAMPOS",
    tituloApoioCreditos: "HỖ TRỢ",
    apoioUmCreditos: "NHÓM MAFMINE",
    localizacaoCreditos: "Hà Nội, Việt Nam",
    dataCreditos: "2023",

    // POPUP REFERENCES
    referenciasTituloPopUp: "TÀI LIỆU THAM KHẢO",
    maisSobreAhpTituloPopUp: "TÀI LIỆU VỀ AHP",
    tituloReferencias: "TÀI LIỆU THAM KHẢO",
    referenciaCardozoArtigo: "CARDOZO, F. A. C. et al. Choice of access for underground mining for feasibility studies. REM-International Engineering Journal, v. 76, p. 187-193, 2023.",
    referenciaCardozoTese: "CARDOZO, F. A. C. Underground Excavation Modeling: Contributions to the Choice of Mine Accesses. Doctorate—Porto Alegre: Federal University of Rio Grande do Sul, March 3, 2023.",
    referenciaAtaei: "ATAEI, M. et al. Mining Method Selection By AHP Approach. Journal of the Southern African Institute of Mining and Metallurgy, v. 108, n. 12, p. 741–749, 2008.",
    referenciaShariar: "SHAHRIAR, K. et al. A New Numerical Method And AHP For Mining Method Selection. Proc. 4th Int. Symp, on 'High performance mine production. p. 289–306. 2007.",
    referenciaBanda: "BANDA, W. An integrated framework comprising of AHP, expert questionnaire survey and sensitivity analysis for risk assessment in mining projects. International Journal of Management Science and Engineering Management, v. 14, n. 3, p. 180-192, 2019.",
    referenciaSaaty: "SAATY, T. L. How to make a decision: the analytic hierarchy process. European journal of operational research, 48(1), 9-26. 1996",
    referenciaRibeiro: "RIBEIRO, M. C. D. C. R., & da Silva Alves, A. Application of the Analytic Hierarchy Process (AHP) method with absolute measurement in a qualitative selection problem. Sistemas & Gestão, 11(3), 270-281. 2016. ",

    // POPUP REPORT ERROR
    reportarErroTituloPopUp: "BÁO CÁO LỖI",
    userNameReportarErro: "Tên của bạn:",
    userEmailReportarErro: "Email của bạn:",
    userMessageReportarErro: "Nội dung lỗi:",
    botaoEnviarReportarErro: "GỬI",

    // MCDM INPUTS
    tituloMcdm: "LỰA CHỌN PHƯƠNG PHÁP TIẾP CẬN CHO MỎ NGẦM: Phân tích đa tiêu chí",
    mcdmTituloCriterios: "TIÊU CHÍ",
    mcdmTituloOptions: "PHƯƠNG ÁN",
    inputNomeLabelCriterios: "Nhập và đặt tên các tiêu chí lựa chọn bên dưới",
    inputNomeLabelOptions: "Nhập và đặt tên các phương án để so sánh bên dưới",
    inputSimboloLabel: "Ký hiệu",

    // FIRST STEP
    tituloMatrizSegundaEtapaAhp: "So sánh cặp tiêu chí",

    // RESULTS STAGE
    matrizPrioridadesGlobais: "Tiêu chí",
    vetorPrioridadeGlobal: "Phương án",
    tituloPesoGlobal: "Trọng số tiêu chí",

    // AHP RIGHT SIDEBAR MENU
    helpEscalaSaaty: "THANG ĐO AHP",
    helpMaisSobreAhp: "TÌM HIỂU THÊM VỀ AHP",
    helpPrimeiraEtapa: "TRỢ GIÚP BƯỚC 1",
    helpSegundaEtapa: "TRỢ GIÚP BƯỚC 2",
    helpResultadosEtapa: "TRỢ GIÚP KẾT QUẢ",

    // POPUP MORE ABOUT AHP
    tituloMaisSobreAhp: "TÌM HIỂU THÊM VỀ AHP",

    // POPUP SAATY SCALE TABLE
    tituloEscalaSaaty: "THANG ĐO SO SÁNH",
    verbalEscalaSaaty: "Bằng lời",
    numericaEscalaSaaty: "Số",
    igualImportanciaEscalaSaaty: "Quan trọng như nhau",
    moderadamenteSuperiorEscalaSaaty: "Quan trọng hơn vừa phải",
    superiorEscalaSaaty: "Quan trọng hơn",
    muitoSuperiorEscalaSaaty: "Rất quan trọng hơn",
    extremamenteSuperiorEscalaSaaty: "Cực kỳ quan trọng hơn",
    legendaEscalaSaaty: "Các giá trị 2,4,6 và 8 là trung gian.",

    // POPUP AHP STEPS
    helpCalculosAhp: "TỪNG BƯỚC",
    passosAhpTituloPopUp: "CÁC BƯỚC AHP",
    tituloAhpPassos: "CÁC BƯỚC AHP",
    ahpPassoUm: "1 - TẠO MA TRẬN SO SÁNH CẶP",
    ahpPassoUmUm: "Sử dụng thang đo so sánh cặp AHP",
    ahpPassoUmDois: "Đánh giá từng phần tử trong hàng của ma trận so với phần tử trong cột",
    ahpPassoDois: "2 - TỔNG CÁC CỘT CỦA MA TRẬN ĐÁNH GIÁ",
    ahpPassoDoisUm: "Tính tổng từng cột riêng lẻ (một giá trị tổng cho mỗi tiêu chí).",
    ahpPassoTres: "3 - CHUẨN HÓA MA TRẬN ĐÁNH GIÁ",
    ahpPassoTresUm: "Chia mỗi phần tử trong các cột của ma trận cho tổng của cột đó",
    ahpPassoQuatro: "4 - TÍNH VECTOR TRỌNG SỐ CỦA MỖI TIÊU CHÍ (W)",
    ahpPassoQuatroUm: "Trọng số của mỗi tiêu chí bằng trung bình cộng của hàng tương ứng trong ma trận chuẩn hóa.",
    ahpPassoCinco: "5 - TÍNH VECTOR TỔNG CÓ TRỌNG SỐ (WS)",
    ahpPassoCincoUm: "Vector WS là kết quả của việc nhân ma trận đánh giá ban đầu với vector trọng số tiêu chí",
    ahpPassoSeis: "6 - TÍNH VECTOR NHẤT QUÁN",
    ahpPassoSeisUm: "Vector nhất quán là kết quả của việc chia vector WS cho vector trọng số tiêu chí (W)",
    ahpPassoSete: "7 - TÍNH GIÁ TRỊ RIÊNG LỚN NHẤT CỦA MA TRẬN ĐÁNH GIÁ",
    ahpPassoSeteUm: "Giá trị riêng lớn nhất (λmax) bằng trung bình cộng của các phần tử của vector nhất quán.",
    ahpPassoOito: "8 - TÍNH CHỈ SỐ NHẤT QUÁN (CI)",
    ahpPassoOitoUm: "CI = (λmax − n)/(n − 1), trong đó n là bậc của ma trận.",
    ahpPassoOitoDois: "Ví dụ về không nhất quán: A>B, B>C và C>A",
    ahpPassoNove: "9 - LẤY CHỈ SỐ NGẪU NHIÊN (RI) CHO MA TRẬN ĐÁNH GIÁ",
    ahpPassoNoveUm: "Chỉ số ngẫu nhiên là giá trị được lập bảng (Saaty, 1991), đại diện cho chỉ số nhất quán trung bình của các ma trận đối xứng được tạo bởi các giá trị ngẫu nhiên.",
    ahpPassoDez: "10 - TÍNH TỶ SỐ NHẤT QUÁN (CR)",
    ahpPassoDezUm: "CR cho biết ma trận đánh giá nhất quán như thế nào so với các ma trận được tạo ngẫu nhiên.",
    ahpPassoDezDois: "CR = CI/RI",
    ahpPassoOnze: "11 - PHÂN TÍCH KẾT QUẢ",
    ahpPassoOnzeUm: "Nếu CR < 0.1, ma trận đánh giá đã được xây dựng thành công và có thể sử dụng trọng số.",
    ahpPassoOnzeDois: "Nếu CR >= 0.1, ma trận đánh giá không nhất quán và phải bắt đầu lại quy trình (quay lại bước 1)"

}

export default translation
